<template>
  <div class="already-receive-list">
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="分批申请单号:" prop="deliveryNum">
        <el-input v-model.trim="searchForm.deliveryNum" placeholder="请输入分批申请单号" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="masterContractNum">
        <el-input v-model.trim="searchForm.masterContractNum" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" placeholder="请输入合同编号" @blur="salaryChange" />
      </el-form-item>
      <el-form-item label="项目名称:" prop="masterProjectName">
        <el-input v-model.trim="searchForm.masterProjectName" placeholder="请输入发货单号" />
      </el-form-item>
      <el-form-item label="申请日期:" prop="startTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-form-item label="未分配金额:" prop="startAssignAmount">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-input v-model.trim="searchForm.startAssignAmount" />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-input v-model.trim="searchForm.endAssignAmount" />
            </div>
          </div>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
        <!-- 导出功能 -->
        <el-button type="warning" @click="importAssignment">
          导入分配
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <!-- <el-table-column prop="StateClass" label="操作" width="90" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="removeApply(row)" v-if="row.processState ==1 && row.processState">
              撤销
            </el-button>
          </template>
        </el-table-column> -->
        <el-table-column prop="deliveryNum" label="分批申请单号" align="left" fixed="left" width="140">
          <template v-slot="{row}">
            <el-button type="text" @click="numberClick(row)">
              {{ row.deliveryNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterContractNum" label="合同编号" align="left" fixed="left" width="140">
          <template v-slot="{row}">
            <el-button type="text" @click="numberContract(row)">
              {{ row.masterContractNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterProjectName" label="项目名称" align="left" min-width="180" />
        <el-table-column prop="amountSum" label="分批发货金额" align="right" header-align="left" min-width="110" />
        <el-table-column prop="createTime" label="申请日期" align="left" width="140" />
        <el-table-column prop="assignAll" label="已分配金额" align="right" header-align="left" min-width="110" />
        <el-table-column prop="unAssignAll" label="未分配金额" align="right" header-align="left" min-width="110" />
        <!-- <el-table-column prop="proportion" label="发货单号" align="left" width="">
          <template v-slot="{row}">
            <el-button type="text" @click="deliverClick(row)">{{ row.invoiceNum }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="proportion" label="物流单号" align="left" width="">
          <template v-slot="{row}">
            <el-button type="text" @click="logistClick(row)">{{ row.logisticsNum }}</el-button>
          </template>
        </el-table-column> -->
        <el-table-column prop="proportion" label="操作" align="left" fixed="right" width="100px">
          <!-- <template v-slot="{row}"> -->
          <template v-slot="{row}">
            <el-button type="text" @click="distribution(row)">
              分配
            </el-button>
          </template>
          <!-- </template> -->
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="发货产品清单" :visible.sync="receiptProductVisible" width="800px">
      <delivery-receipt-product-list
        v-if="receiptProductVisible"
        :receipt-number="receiptNumber"
        :contract-code="contractCode"
        :order-number="orderNumber"
      />
    </el-dialog>
    <el-dialog title="回单信息" :visible.sync="receiptVisible" width="700px">
      <receipt-list v-if="receiptVisible" :receipt-form="receiptForm" :is-show="isShow" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="receiptVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <importAssignment :dialog-form-visible="dialogFormVisibleImport" @on-status-dialog="updataDialogFormVisibleImport" />

    <partShipCheck :id="partId" :dialog-form-visible="dialogFormVisible" @on-status-dialog="updataDialogFormVisible" />
    <deliverGoodsNumber :dialog-form-visible-deliver="dialogFormVisibleDeliver" :form="formNum" @on-status-dialog="updataDialogFormVisibleDeliver" />
    <logisticsNumber :dialog-form-visible-logist="dialogFormVisibleLogist" :form="formNum" @on-status-dialog="updataDialogFormVisibleLogist" />
  </div>
</template>

<script>
import { needAllocatePartialInvoice } from '@/API/index.js';
import eventBus from '@/libs/eventBus.js';
import deliveryReceiptProductList from './deliveryReceiptProductList';
import receiptList from './receiptList';
import importAssignment from './importAssignment.vue';
import partShipCheck from '../../partShipCheck';
import deliverGoodsNumber from '../../partShipCheck/deliverGoodsNumber';
import logisticsNumber from '../../partShipCheck/logisticsNumber';
export default {
  name: 'AlreadyReceiveList',
  data () {
    return {
      tableLoading: false,
      receiptProductVisible: false,
      // 定义组件
      dialogFormVisible: false,
      dialogFormVisibleDeliver: false,
      dialogFormVisibleLogist: false,
      dialogFormVisibleImport: false,
      exportUrl: '',
      formNum: {},
      searchForm: {
        deliveryNum: '',
        masterContractNum: '',
        masterProjectName: '',
        startTime: '',
        endTime: '',
        startAssignAmount: '',
        endAssignAmount: ''
      },
      tableData: [],
      partId: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      receiptNumber: '',
      contractCode: '',
      orderNumber: '',
      receiptVisible: false,
      receiptForm: {},
      isShow: false,
      // 召回参数
      dialogVisible: false,
      deleteReason: ''

    };
  },
  components: {
    importAssignment,
    deliveryReceiptProductList,
    receiptList,
    partShipCheck,
    deliverGoodsNumber,
    logisticsNumber
  },
  methods: {
    // blur
    salaryChange (e) {
      this.searchForm.masterContractNum = (e.target.value || '').trim();
    },
    // 组件事件
    updataDialogFormVisibleImport (val) {
      this.dialogFormVisibleImport = val;
    },
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },
    importAssignment () {
      this.dialogFormVisibleImport = true;
    },
    initData () {
      this.tableLoading = true;
      let params = {
        deliveryNum: this.searchForm.deliveryNum,
        masterContractNum: this.searchForm.masterContractNum,
        masterProjectName: this.searchForm.masterProjectName,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        startAssignAmount: this.searchForm.startAssignAmount,
        endAssignAmount: this.searchForm.endAssignAmount,
        pageSize: this.page.pageSize,
        pageIndex: this.page.currentPage
      };
      needAllocatePartialInvoice(params).then((res) => {
        let json = res.data;

        this.tableLoading = false;
        if (json.status === '200') {
          this.page.currentPage = json.data.pageNum;
          this.page.total = json.data.total;
          this.tableData = json.data.list;
          this.tableData.forEach((item) => {
            this.$set(item, 'textarea', '');
          });
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
        }
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    resetForm () {
      this.$refs['searchForm'].resetFields();
      this.searchForm.endTime = '';
      this.searchForm.endAssignAmount = '';
      this.page.currentPage = 1;
      this.initData();
    },
    doSearch () {
      this.page.currentPage = 1;
      this.initData();
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = '实际结算金额';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = '未发货数量';
        }
      });
      return sums;
    },

    detailProductList (row) {
      this.receiptProductVisible = true;
      this.receiptNumber = row.ReceiptNumber;
      this.contractCode = row.ContractNumber;
      this.orderNumber = row.ERPNumber;
    },
    handerSizeChange () {
      this.page.currentPage = 1;
      this.initData();
    },
    handerCurrentChange () {
      this.initData();
    },
    pickerOptions () {

    },
    numberClick (row) {
      this.partId = row.id;
      this.dialogFormVisible = true;
    },
    numberContract (row) {
      this.$router.push({ name: 'ContractInfo', params: { contractNum: row.masterContractNum }, query: { id: row.masterContractId, masterProjectName: row.masterProjectName } });
    },
    distribution (row) {
      this.$router.push({ name: 'BatchBase', query: row });
    },
    // 组件事件
    updataDialogFormVisibleDeliver (val) {
      this.dialogFormVisibleDeliver = val;
    },
    // 组件事件
    updataDialogFormVisibleLogist (val) {
      this.dialogFormVisibleLogist = val;
    },
    deliverClick (row) {
      this.formNum = row;
      this.dialogFormVisibleDeliver = true;
    },
    logistClick (row) {
      this.formNum = row;
      this.dialogFormVisibleLogist = true;
    }

  },
  mounted () {
    this.initData();
    eventBus.$on('changescom', () => {
      this.initData();
    });
  }
};
</script>

<style scoped>

</style>
